enum CallPutType {
    C = "Call",
    P = "Put",
}

export default CallPutType;